import { Card, Divider, Image, Tooltip, Space, Typography } from "antd";
import { DeleteOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { Button as UploadButton } from "@mui/material";
import { showMessage } from "../Utils/message";
import { useSelector } from "react-redux";
const { Title } = Typography;

export const FileImageSection = ({
  title,
  icon,
  items,
  newItems,
  handleDeleteOld,
  handleDeleteNew,
  renderImage = false,
  baseUrl,
  folderName,
  env,
  id,
  uploadLabel,
  uploadHandler,
  uploadLimit = 10,
  accept = "*",
  multiple = true,
  single = false, // 🆕 flag to enable single-file mode
}) => {
  const { roles, type: roleType } = useSelector(
    (state) => state?.AppState?.userCreds
  );

  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const hasOld = single
    ? !!items // string or falsy
    : Array.isArray(items) && items.length > 0;

  const hasNew = single
    ? !!newItems // object or falsy
    : Array.isArray(newItems) && newItems.length > 0;

  return (
    <Card
      size="small"
      style={{
        marginBottom: 16,
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
      bodyStyle={{ padding: 4 }}
      title={
        <Space>
          {icon}
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
        </Space>
      }
      extra={
        canAccess && (
          <UploadButton
            component="label"
            variant="contained"
            size="small"
            startIcon={<CloudUploadOutlined />}
            sx={{
              fontSize: "12px",
              borderRadius: "8px",
              textTransform: "none",
              backgroundColor: "#1677ff",
              "&:hover": { backgroundColor: "#0958d9" },
            }}
          >
            {uploadLabel}
            <input
              type="file"
              hidden
              multiple={!single && multiple} // 🆕 single mode disables multiple
              accept={accept}
              capture
              onClick={(e) => (e.target.value = "")}
              onChange={(e) => {
                const myfiles = e.target.files;
                if (!single && myfiles.length > uploadLimit) {
                  showMessage("error", `Maximum ${uploadLimit} files allowed.`);
                  e.target.value = "";
                } else {
                  uploadHandler(e);
                }
              }}
            />
          </UploadButton>
        )
      }
    >
      {/* ===================== OLD FILE(S) ===================== */}
      {hasOld ? (
        renderImage ? (
          <Image.PreviewGroup>
            {single ? (
              (() => {
                const encoded = items.replace(/\+/g, "%2B");
                const imageUrl = `${baseUrl}/${env}/${folderName}/${id}/${encoded}`;
                return (
                  <div
                    style={{
                      position: "relative",
                      margin: 5,
                      display: "inline-block",
                    }}
                  >
                    <Image
                      width={150}
                      height={100}
                      style={{
                        borderRadius: 8,
                        border: "1px solid #eaeaea",
                      }}
                      src={imageUrl}
                    />
                    <Tooltip title="Delete">
                      <DeleteOutlined
                        style={{
                          fontSize: 22,
                          position: "absolute",
                          right: 8,
                          top: 8,
                          color: "#ff4d4f",
                          cursor: "pointer",
                          background: "rgba(255,255,255,0.8)",
                          borderRadius: "50%",
                          padding: 4,
                        }}
                        onClick={() => handleDeleteOld(items)}
                      />
                    </Tooltip>
                  </div>
                );
              })()
            ) : (
              items
                .filter((item) => !newItems.some((f) => f.name === item))
                .map((item, idx) => {
                  const encoded = item.replace(/\+/g, "%2B");
                  const imageUrl = `${baseUrl}/${env}/${folderName}/${id}/${encoded}`;
                  return (
                    <div
                      key={idx}
                      style={{
                        position: "relative",
                        margin: 5,
                        display: "inline-block",
                      }}
                    >
                      <Image
                        width={150}
                        height={100}
                        style={{
                          borderRadius: 8,
                          border: "1px solid #eaeaea",
                        }}
                        src={imageUrl}
                      />
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          style={{
                            fontSize: 22,
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "#ff4d4f",
                            cursor: "pointer",
                            background: "rgba(255,255,255,0.8)",
                            borderRadius: "50%",
                            padding: 4,
                          }}
                          onClick={() => handleDeleteOld(item)}
                        />
                      </Tooltip>
                    </div>
                  );
                })
            )}
          </Image.PreviewGroup>
        ) : (
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {single ? (
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                  background: "#fafafa",
                  padding: "6px 10px",
                  borderRadius: 6,
                }}
              >
                <Tooltip title="Delete">
                  <DeleteOutlined
                    style={{ color: "#ff4d4f", marginRight: 8, cursor: "pointer" }}
                    onClick={() => handleDeleteOld(items)}
                  />
                </Tooltip>
                <a
                  href={`${baseUrl}/${env}/${folderName}/${id}/${items}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {items}
                </a>
              </li>
            ) : (
              items
                .filter((item) => !newItems.some((f) => f.name === item))
                .map((item, idx) => {
                  const encoded = item.replace(/\+/g, "%2B");
                  return (
                    <li
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 8,
                        background: "#fafafa",
                        padding: "6px 10px",
                        borderRadius: 6,
                      }}
                    >
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          style={{
                            color: "#ff4d4f",
                            marginRight: 8,
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteOld(item)}
                        />
                      </Tooltip>
                      <a
                        href={`${baseUrl}/${env}/${folderName}/${id}/${encoded}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item}
                      </a>
                    </li>
                  );
                })
            )}
          </ul>
        )
      ) : (
        <></>
      )}

      <Divider dashed style={{ margin: 1 }} />

      {/* ===================== NEW FILE(S) ===================== */}
      {hasNew ? (
        renderImage ? (
          <Image.PreviewGroup>
            {single ? (
              <div
                style={{
                  position: "relative",
                  margin: 5,
                  display: "inline-block",
                }}
              >
                <Image
                  width={150}
                  height={100}
                  style={{
                    borderRadius: 8,
                    border: "1px solid #eaeaea",
                  }}
                  src={URL.createObjectURL(newItems.file)}
                />
                <Tooltip title="Delete">
                  <DeleteOutlined
                    style={{
                      fontSize: 22,
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: "#52c41a",
                      cursor: "pointer",
                      background: "rgba(255,255,255,0.8)",
                      borderRadius: "50%",
                      padding: 4,
                    }}
                    onClick={() => handleDeleteNew(newItems.name)}
                  />
                </Tooltip>
              </div>
            ) : (
              newItems.map((f, idx) => (
                <div
                  key={idx}
                  style={{
                    position: "relative",
                    margin: 5,
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={150}
                    height={100}
                    style={{
                      borderRadius: 8,
                      border: "1px solid #eaeaea",
                    }}
                    src={URL.createObjectURL(f.file)}
                  />
                  <Tooltip title="Delete">
                    <DeleteOutlined
                      style={{
                        fontSize: 22,
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "#52c41a",
                        cursor: "pointer",
                        background: "rgba(255,255,255,0.8)",
                        borderRadius: "50%",
                        padding: 4,
                      }}
                      onClick={() => handleDeleteNew(f.name)}
                    />
                  </Tooltip>
                </div>
              ))
            )}
          </Image.PreviewGroup>
        ) : (
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {single ? (
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                  background: "#f6ffed",
                  padding: "6px 10px",
                  borderRadius: 6,
                }}
              >
                <Tooltip title="Delete">
                  <DeleteOutlined
                    style={{ color: "#52c41a", marginRight: 8, cursor: "pointer" }}
                    onClick={() => handleDeleteNew(newItems.name)}
                  />
                </Tooltip>
                {newItems.name}
              </li>
            ) : (
              newItems.map((f, idx) => (
                <li
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                    background: "#f6ffed",
                    padding: "6px 10px",
                    borderRadius: 6,
                  }}
                >
                  <Tooltip title="Delete">
                    <DeleteOutlined
                      style={{ color: "#52c41a", marginRight: 8, cursor: "pointer" }}
                      onClick={() => handleDeleteNew(f.name)}
                    />
                  </Tooltip>
                  {f.name}
                </li>
              ))
            )}
          </ul>
        )
      ) : (
        <></>
      )}
    </Card>
  );
};
